export { default } from './TextareaAutosize';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/TextareaAutosize/index.js
// module id = 565
// module chunks = 2